// extracted by mini-css-extract-plugin
module.exports = {"contentLicenses":"licenses_contentLicenses_2_85v"};